import { Dispatch, SetStateAction, useEffect } from 'react';
import { useFormState } from 'react-hook-form';
import { trackTap } from 'utils/functions/analytics';

type TrackFormProps = {
  trigger: [string, Dispatch<SetStateAction<string>>];
  eventType: string;
  fieldsMap: { [key: string]: string };
  errorsMap: { [key: string]: string };
};

export const TrackForm = ({
  trigger,
  eventType = '',
  fieldsMap,
  errorsMap,
}: TrackFormProps) => {
  const formState = useFormState();
  const [triggerAnalytics, setTriggerAnalytics] = trigger;
  useEffect(() => {
    const fieldError = formState.errors[triggerAnalytics];

    if (triggerAnalytics && fieldError) {
      const errorMessage = fieldError.message;
      if (errorMessage && typeof errorMessage === 'string') {
        trackTap({
          event_type: eventType,
          error_field: fieldsMap[triggerAnalytics] ?? triggerAnalytics,
          error_type: errorsMap[errorMessage] ?? errorMessage,
        });
        setTriggerAnalytics('');
      }
    }
  }, [triggerAnalytics]);

  return null;
};
